<template>
    <footer :class="['footer', {'white-text': bgColor}]" :style="{backgroundColor: bgColor ? bgColor : '#fff'}">

        <div class="wrap-footer">
            <div class="left">
                <h2 v-if="showContact" class="h1">{{contactTitle}}</h2>
            </div>

            <div class="center">
                <div class="wrap-center">
                    <div class="address" v-if="address.street && showAddress">

                        <h4 v-if="addressTitle">{{addressTitle}}</h4>
                        <template v-if="addressLink">
                            <a target="_blank" :href="addressLink">
                                <p>{{address.street}},</p>
                                <p>{{address.city}}, {{address.state}} {{address.zip}}</p>
                            </a>
                        </template>
                        <template v-else>
                            <p>{{address.street}},</p>
                            <p>{{address.city}}, {{address.state}} {{address.zip}}</p>
                        </template>

                        <div class="phone">
                            <a :href="`tel:${phone}`">{{phone}}</a>
                        </div>

                    </div>

                    <div v-if="hours && showHours" class="hours">
                        <h4>{{hoursTitle}}</h4>
                        <div v-html="hours.hours"></div>

                        <div class="social-media">
                            <h4>Social</h4>
                            <social-media :social-media="socialMedia" />
                        </div>
                    </div>

                </div>
            </div>

            <div class="right">
                <div class="img-container">
                    <router-link class="router" v-if="footerLogoLink && footerLogoLink.target !== '_blank'"
                                 :to="internalURL">
                        <wp-image :image="footerLogo" />
                    </router-link>
                    <a class="regular" v-else-if="footerLogoLink && footerLogoLink.target === '_blank'"
                                 :href="footerLogoLink.url"
                                 target="_blank">
                        <wp-image :image="footerLogo" />
                    </a>
                    <wp-image v-else :image="footerLogo" />

                </div>
            </div>
        </div>


        <div class="copyright">
            <div v-if="permalinks.length" class="wrap-permalinks">
              <a v-for="(linkObj, index) in permalinks"
                 :key="`permalink-${index}`"
                 :target="linkObj.link.target"
                 :href="linkObj.link.url"
                 :title="linkObj.link.title"
              >{{linkObj.link.title}}</a>
            </div>
            <div class="wrap-copyright" v-html="copyright"></div>

        </div>

    </footer>
</template>

<script>
    import FooterLogo from './FooterLogo'
    import SocialMedia from './SocialMedia'
    import SectionHeading from '../components/SectionHeading'
    import ButtonLink from '../components/ButtonLink'
    import EqualHousingSvg from '../svgs/EqualHousingSvg';
    import {EventBus} from "../../utils/eventBus";

    export default {
        name: "ThemeFooter",
        components: {
            FooterLogo,
            SectionHeading,
            SocialMedia,
            EqualHousingSvg,
            ButtonLink
        },
        data() {
            return {
                logoHoverOn: false,
            }
        },
        computed: {
            bgColor() {
                if (EventBus.bgFooter === '') return false;
                return EventBus.bgFooter;
            },
            upArrow() {
                return faChevronUp
            },
            footerOptions(){
                return wp.settings && wp.settings.footer_options;
            },
            phone(){
                return wp.settings && wp.settings.phone_number;
            },
            hoursTitle(){
                return this.footerOptions && this.footerOptions.hours_title;
            },
            hours(){
                return wp.settings && wp.settings.hours;
            },
            permalinks(){
              return this.footerOptions && this.footerOptions.links;
            },
            showContact(){
                return this.footerOptions && this.footerOptions.show_contact_column
            },
            contactTitle(){
                return this.footerOptions && this.footerOptions.contact_column_title
            },
            showAddress(){
                return this.footerOptions && this.footerOptions.show_location_column
            },
            showHours(){
                return this.footerOptions && this.footerOptions.show_hours_column
            },
            addressTitle(){
                return this.footerOptions && this.footerOptions.location_title;
            },
            address(){
                return wp.settings && wp.settings.address;
            },
            addressLink() {
                return wp.settings && wp.settings.google_maps_address;
            },
            footerLogo() {
                return this.footerOptions && this.footerOptions.footer_logo
            },
            footerLogoLink() {
                return this.footerOptions && this.footerOptions.footer_logo_link
            },
            internalURL(){
                return this.footerLogoLink.url.replace(location.origin, '')
            },
            copyright() {
                return this.footerOptions && this.footerOptions.copyright
            },
        }
    }
</script>

<style lang="scss" scoped>

    .footer{
        background-color: #fff;
        @include max-width();
        margin: auto;
        min-height: 400px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 5;
        box-shadow: 0 -20px 90px rgba(0, 0, 0, 0.15);

        &.white-text{
            *{
                color: #fff;
            }

            /deep/ a{
                color: #fff !important;
            }
        }

        @media (max-width: 1250px){
            padding: 0 30px
        }

        @media (max-width: 992px){
            min-height: 320px;
            padding-bottom: 30px;
        }

        @media (max-width: 767px){
            min-height: auto;
            position: relative;
            padding: 0 0 30px;
        }
    }

    .white-text{
        /deep/ img {
            filter: contrast(0) brightness(100);
        }
    }

    .wrap-footer{
        max-width: calc(100% - 200px);
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        padding: 127px 0 40px;

        @media (max-width: 1350px){
            max-width: calc(100% - 60px);
        }

        @media (max-width: 1250px){
            padding-top: 40px;
        }

        @media (max-width: 767px){
            padding-top: 30px;
        }

        .left{
            width: 420px;
            padding-right: 30px;

            @media (max-width: 1350px){
                width: calc(100% / 3 + 15px);
            }

            @media (max-width: 1250px){
                width: 50%;
            }

            @media (max-width: 767px){
                width: 100%;
            }

        }

        .center{
            width: 385px;

            @media (max-width: 1350px){
                width: calc(100% / 3 + 15px);
                padding-left: 15px;
            }

            @media (max-width: 1250px){
                width: 50%;
                padding-left: 0;
            }

            @media (max-width: 767px){
                width: 100%;
                margin-top: 30px;
            }

            .wrap-center{
                display: flex;
                justify-content: space-between;
                font-size: 15px;

                @media (max-width: 1250px){
                    justify-content: space-around;
                }

                @media (max-width: 767px){
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .address{
                        margin-bottom: 30px;
                    }
                }

                h4{
                    font-size: 15px;
                    font-weight: $font-weight--light;
                    margin: 0;
                    text-transform: uppercase;

                    @media (max-width: 992px){
                        line-height: 20px;
                    }
                }

                a{
                    color: $color1;
                    text-decoration: none;
                    transition: all .3s ease-in-out;

                    &:hover{
                        color: $color2;
                    }
                }

                .phone {
                    padding-top: 10px;
                }
            }

            .social-media h4 {
                margin-top: 20px;
            }
        }

        .right{
            width: calc(100% - 420px - 385px);

            @media (max-width: 1350px){
                width: calc(100% / 3 - 30px);
            }

            @media (max-width: 1250px){
                width: 100%;
                margin-top: 50px;
            }

            @media (max-width: 767px){
                width: 100%;
            }

            .img-container{
                max-width: 170px;
                float: right;

                @media (max-width: 1250px){
                    float: left;
                }
            }
        }
    }

    .copyright{
        max-width: calc(100% - 200px);
        margin: 50px auto 0;

        @media (max-width: 1350px){
            max-width: calc(100% - 60px);
        }

        @media (max-width: 992px){
            margin-top: 20px;
        }

        .wrap-copyright{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            flex-wrap: wrap;


            /deep/ {

                .left{

                    @media (max-width: 992px){
                        max-width: 330px;
                        width: calc(100% - 100px);
                    }
                    a{
                        color: $color1;
                        text-decoration: none;

                        &:hover{
                            color: $color2;
                        }
                    }
                }

                .right{
                    img{
                        width: 50px;
                    }
                }
            }
        }
    }

    .wrap-permalinks {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 15px;

      a{
        font-size: 15px;
        margin-right: 10px;
        color: #244454;
        text-decoration: none;
        transition: all .3s ease-in-out;
        display: block;
        margin-bottom: 5px;
      }
    }

</style>
